/** @jsxImportSource @emotion/react */
import { Checkbox, Modal } from "antd";
import { AnnouncementApi } from "api/announcement";
import { icons } from "assets/mobile";
import { ResponseCode } from "contants/response";
import { useAppSelector } from "hooks/app-hook";
import { useEffect, useState } from "react";
import { selectIsAuthenticated } from "store/auth";
import { AnnouncementItemType } from "types/announcement";

import { ModalAnnouncementStyle } from "./index.style";
import ModalDetail from "./ModalDetail";

const keyStorage = "modalAnnouncement";
function ModalAnnouncement() {
  const isAuth = useAppSelector(selectIsAuthenticated);
  const [data, setData] = useState<AnnouncementItemType[]>([]);
  const [dataItem, setDataItem] = useState<AnnouncementItemType | null>(null);
  const [isOpen, setIsOpen] = useState<boolean>(false);
  useEffect(() => {
    const cookie = document.cookie.split(";");
    if (!isAuth && !cookie.includes(`${keyStorage}=true`)) {
      getData();
    }
  }, []);
  const getData = async () => {
    const res = await AnnouncementApi.getAnnouncement({
      page: 1,
      type: 1,
      size: 100,
    });
    const resData = res.data;
    if (resData.status === ResponseCode.SUCCESS) {
      if (resData.data.length) {
        setIsOpen(true);
        setData(resData.data);
      }
    }
  };
  const renderItem = (item: AnnouncementItemType, index: number) => {
    return (
      <div
        onClick={() => setDataItem(item)}
        css={ModalAnnouncementStyle.item}
        key={`item-announcement-${index}`}
      >
        <icons.MessageIcon className="message" />
        <span>{item.title}</span>
        <icons.ArrowRightIcon className="arrow-right" />
      </div>
    );
  };
  return (
    <Modal
      open={isOpen}
      centered
      footer={<></>}
      focusTriggerAfterClose={false}
      forceRender
      closable={false}
      css={ModalAnnouncementStyle.modalStyle}
      onCancel={() => setIsOpen(false)}
    >
      <div css={ModalAnnouncementStyle.close}>
        <span onClick={() => setIsOpen(false)} className="close-button">
          <icons.IconFormClose />
        </span>
      </div>
      <div css={ModalAnnouncementStyle.container}>
        <div css={ModalAnnouncementStyle.header}>
          <h3>CASINO - I ONLY CHOOSE JokerMillion</h3>
        </div>
        <div css={ModalAnnouncementStyle.content}>
          {data.map((item, index) => {
            return renderItem(item, index);
          })}
        </div>
        <div
          onClick={() => setIsOpen(false)}
          css={ModalAnnouncementStyle.footer}
        >
          <h3>CLOSE</h3>
        </div>
      </div>
      <div css={ModalAnnouncementStyle.close}>
        <Checkbox
          onChange={(e) => {
            const checked = e.target.checked;
            if (checked) {
              document.cookie = `${keyStorage}=true`;
            } else {
              document.cookie = "";
            }
          }}
          className="checkbox"
        >
          NOT SHOW AGAIN
        </Checkbox>
      </div>
      <ModalDetail item={dataItem} onClose={() => setDataItem(null)} />
    </Modal>
  );
}

export default ModalAnnouncement;
